import { sessionActions } from '../../store'; // Adjust the path if needed

export async function refreshTotalCounts(user, dispatch) {
  if (!user || !user.id) {
    return Promise.reject("Invalid user.");
  }

  try {
    console.log(`Fetching total counts for user ID: ${user.id}`);
    const response = await fetch(`/api/total-counts/user/${user.id}/all`);
    if (response.ok && response.status !== 204) {
      const totalCountsData = await response.json();
      console.log("Total counts data fetched:", totalCountsData);

      let weeklyCounts = { driving: 0, pause: 0, work: 0, other: 0 };
      let monthlyCounts = { driving: 0, pause: 0, work: 0, other: 0 };
      let yearlyCounts = { driving: 0, pause: 0, work: 0, other: 0 };

      if (totalCountsData && totalCountsData[0]) {
        const dateString = totalCountsData[0].workday;
        const givenDate = new Date(dateString);
        const max = 480;

        const today = new Date();
        const todayDateOnly = new Date(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate());

        const isSameDay = givenDate.toISOString().split('T')[0] === todayDateOnly.toISOString().split('T')[0];

        let currentWork = 0, currentDriving = 0, drivingHours = "0:0", workingHours = "0:0";

        if (isSameDay) {
          currentWork = (totalCountsData[0].work * 100) / max;
          currentDriving = (totalCountsData[0].driving * 100) / max;
          const hours = Math.floor(totalCountsData[0].driving / 60);
          const remainingMinutes = Math.floor(totalCountsData[0].driving % 60);
          drivingHours = `${hours}:${remainingMinutes}`;
          const workHours = Math.floor(totalCountsData[0].work / 60);
          const workMinutes = totalCountsData[0].work % 60;
          workingHours = `${workHours}:${workMinutes}`;
        }

        // Update data with calculated fields
        totalCountsData[0].drivingHours = drivingHours;
        totalCountsData[0].workingHours = workingHours;
        totalCountsData[0].currentDriving = currentDriving;
        totalCountsData[0].currentWork = currentWork;

        // Dispatch to Redux
        console.log("Dispatching updated total counts:", totalCountsData);
        dispatch(sessionActions.updateTotalCounts(totalCountsData));

        // Save to sessionStorage
        sessionStorage.setItem("totalCounts", JSON.stringify(totalCountsData));

        const startOfWeek = getStartOfWeek(today);
        const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const startOfYear = new Date(today.getFullYear(), 0, 1);

        totalCountsData.forEach((record) => {
          const recordDate = new Date(record.workday);

          if (recordDate >= startOfWeek) {
            weeklyCounts.driving += record.driving;
            weeklyCounts.pause += record.pause;
            weeklyCounts.work += record.work;
            weeklyCounts.other += record.other;
          }

          if (recordDate >= startOfMonth) {
            monthlyCounts.driving += record.driving;
            monthlyCounts.pause += record.pause;
            monthlyCounts.work += record.work;
            monthlyCounts.other += record.other;
          }

          if (recordDate >= startOfYear) {
            yearlyCounts.driving += record.driving;
            yearlyCounts.pause += record.pause;
            yearlyCounts.work += record.work;
            yearlyCounts.other += record.other;
          }
        });

        // Dispatch to Redux and save to session storage
        dispatch(sessionActions.updateTotalWeekCounts(weeklyCounts));
        dispatch(sessionActions.updateTotalMonthCounts(monthlyCounts));
        dispatch(sessionActions.updateTotalYearCounts(yearlyCounts));

        sessionStorage.setItem("totalWeekCounts", JSON.stringify(weeklyCounts));
        sessionStorage.setItem("totalMonthCounts", JSON.stringify(monthlyCounts));
        sessionStorage.setItem("totalYearCounts", JSON.stringify(yearlyCounts));

        //return {totalCountsData, weeklyCounts, monthlyCounts, yearlyCounts };
        // return totalCountsData; // Success

        return Promise.resolve();

      }else{
          /*const defaultTotalCounts = {
            driving: 0,
            pause: 0,
            other: 0,
            work: 0,
            workday: new Date().toISOString().split('T')[0], // Current day in YYYY-MM-DD format
        };
        
        totalCountsData = totalCounts?.[0] || defaultTotalCounts;

        return Promise.resolve();*/
        //totalCountsData = null;
        return Promise.resolve();
      }
    } else {
      // If fetch fails, fall back to sessionStorage
      const localData = sessionStorage.getItem("totalCounts");
      if (localData) {
        const parsed = JSON.parse(localData);
        dispatch(sessionActions.updateTotalCounts(parsed));
        return Promise.resolve();
      }
      return Promise.reject("Failed to fetch and no local data available.");
      }
  } catch (error) {
    // If fetch fails, fall back to sessionStorage
    const localData = sessionStorage.getItem("totalCounts");
    if (localData) {
      const parsed = JSON.parse(localData);
      dispatch(sessionActions.updateTotalCounts(parsed));
      return Promise.resolve();
    }
    return Promise.reject("Failed to fetch and no local data available.");
  }
}

function getStartOfWeek(date) {
  const dayOfWeek = date.getUTCDay();
  const diff = date.getUTCDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1); // Start from Monday
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), diff);
}